<p class="font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] cursor-pointer">Procurement</p>

<div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg h-screen">

    <div class="flex flex-row gap-x-10">
        <div class=" border border-1 border-[#415CFF] w-56 h-40 pt-6 pb-1 bg-tileLight dark:bg-[#363636] shadow-md rounded-lg cursor-pointer relative"
            (click)="onRedefineClick()"> <!-- Added 'relative' here -->

            <div class="flex flex-col items-center justify-center mx-5 gap-5">
                <div class="bg-[#EDF5FC] p-3 w-12 h-12 flex items-center justify-center rounded-full">
                    <i class="fa-solid fa-arrows-rotate text-[#415CFF] text-lg"></i>
                    <!-- <i class="fa-solid fa-database text-[#415CFF] text-lg"></i> -->
                </div>

                <div class="flex flex-col justify-center items-center text-center">
                    <span class="text-[#292929] dark:text-white font-bold block">Redefine</span>
                    <span class="text-[#292929] dark:text-white font-bold block">Orders</span>
                </div>
            </div>
            <div class="absolute bottom-1 right-2"> <!-- Changed to absolute positioning -->
                <i class="fa-solid fa-arrow-up-right-from-square text-[#415CFF]"></i>
            </div>
        </div>


        <div class="border border-1 border-[#415CFF] w-56 h-40 pt-6 pb-1 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg cursor-pointer relative"
            (click)="onAllRecievedClick()">
            <div class="flex flex-col items-center justify-center mx-5 gap-5 ">
                <div class="bg-[#EDF5FC] p-3 w-12 h-12 flex items-center justify-center rounded-full">
                    <i class="fa-solid fa-cubes-stacked text-[#415CFF] text-xl"></i>
                </div>

                <div class="flex flex-col justify-center items-center text-center">
                    <span class="text-[#292929] dark:text-white font-bold block">All Received</span>
                    <span class="text-[#292929] dark:text-white font-bold block">Orders</span>
                </div>
            </div>
            <div class="absolute bottom-1 right-2"> <!-- Changed to absolute positioning -->
                <i class="fa-solid fa-arrow-up-right-from-square text-[#415CFF]"></i>
            </div>
        </div>
    </div>
</div>